import { Box } from '@factorialco/deprecated-design-system'
import {
  ContractVersionPageContractVersionFragment,
  ContractVersionsPageEmployeeFragment,
  WorkingConditionVersionApplicationFragment,
} from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import MissingData from './MissingData'
import Promotion from './Promotion'
import WorkingConditions from './WorkingConditions'

interface Props {
  selectedContractVersion: ContractVersionPageContractVersionFragment
  employee: ContractVersionsPageEmployeeFragment
  workingConditionVersionApplication?: WorkingConditionVersionApplicationFragment
}

const Tags = ({ selectedContractVersion, employee, workingConditionVersionApplication }: Props) => {
  return (
    <>
      <Box gap="s8" flexDirection="row" alignItems="center">
        <MissingData selectedContractVersion={selectedContractVersion} employee={employee} />
        <Promotion authorName={selectedContractVersion.createdByName ?? ''} />
      </Box>
      {workingConditionVersionApplication && (
        <WorkingConditions
          workingConditionVersionApplication={workingConditionVersionApplication}
        />
      )}
    </>
  )
}

export default observer(Tags)
